module.exports = __webpack_public_path__ + "img/commi_ban.png";